import { render, staticRenderFns } from "./help-link.vue?vue&type=template&id=f8e9d3d0"
import script from "./help-link.vue?vue&type=script&lang=js"
export * from "./help-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports